import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [{
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    meta: {
      title: '首页',
      icon: 'home'
    },
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {
        title: '首页',
        icon: 'home'
      }
    }],

  },
  // ===================== 新增：独立流水详情页 =====================
   {
     path: '/flow-detail', // 独立简洁URL
     component: () => import('@/views/rma/flowAnalysis/detail'), // 原组件
     hidden: true, // 不显示在侧边栏
     meta: {
       title: '流水详细'
     }
   },
   // ==============================================================L
]

export const asyncRouterMap = [{
    path: '/rma',
    component: Layout,
    redirect: '/rma/report',
    name: 'data',
    meta: {
      title: '数据查询',
      icon: 'data'
    },
    children: [{
        path: 'report',
        name: 'data-query',
        component: () => import('@/views/rma/report/index'),
        meta: {
          title: '数据查询',
          icon: 'data-query'
        }
      },
      {
        path: 'history',
        name: 'history-query',
        component: () => import('@/views/rma/report/history'),
        meta: {
          title: '查询历史',
          icon: 'data-history'
        }
      },
      {
        path: 'qualification',
        name: 'qualification',
        component: () => import('@/views/rma/report/qualification'),
        meta: {
          title: '资质查询',
          icon: 'data-history'
        },
        hidden: true
      },
      {
        path: 'historyDetail',
        name: 'historyDetail',
        component: () => import('@/views/rma/report/historyDetail'),
        meta: {
          title: '查询历史详情',
          icon: 'data-history'
        },
        hidden: true
      },
    ]
  },


  {
    path: '/judge',
    component: Layout,
    redirect: '/judge/phoneJudge',
    name: 'phone-judge',
    meta: {
      title: '校验比对',
      icon: 'risk-query'
    },
    children: [{
      path: 'phoneJudge',
      name: 'phone-judge',
      component: () => import('@/views/rma/phoneJudge/index'),
      meta: {
        title: '校验比对',
        icon: 'phone-judge'
      }
    }]
  },


  {
    path: '/analysis',
    component: Layout,
    redirect: '/analysis/flowAnalysis',
    name: 'flow-analysis',
    meta: {
      title: '流水分析',
      icon: 'flow-analysis'
    },
    children: [{
        path: 'entrance',
        name: 'entrance',
        component: () => import('@/views/rma/flowAnalysis/entrance'),
        meta: {
          title: '操作引导',
          icon: 'entrance-guidance'
        }
      },
      {
        path: 'flowAnalysis',
        name: 'flow-query',
        component: () => import('@/views/rma/flowAnalysis/index'),
        meta: {
          title: '流水查询',
          icon: 'report-query'
        }
      },
      // {
      //   path: 'flowAnalysisDetail',
      //   name: 'flowAnalysisDetail',
      //   component: () => import('@/views/rma/flowAnalysis/detail'),
      //   meta: {
      //     title: '流水详细',
      //     icon: 'data-history'
      //   },
      //   hidden: true
      // },
    ]
  },

  {
    path: '/ris',
    component: Layout,
    redirect: '/ris/riskQuery',
    name: 'risk-query',
    meta: {
      title: '真假分析',
      icon: 'risk-query'
    },
    children: [{
      path: 'riskQuery',
      name: 'risk-query',
      component: () => import('@/views/rma/riskQuery/index'),
      meta: {
        title: '真假分析',
        icon: 'risk-query'
      }
    }]
  },
  {
    path: '/con',
    component: Layout,
    redirect: '/con/consume',
    name: 'consumption',
    meta: {
      title: '消费记录',
      icon: 'consume-record'
    },
    children: [{
      path: 'consumption',
      name: 'consumption',
      component: () => import('@/views/rma/consume/index'),
      meta: {
        title: '消费记录',
        icon: 'consume-record'
      }
    }]
  },
  {
    path: '/flo',
    component: Layout,
    redirect: '/flo/flowReport',
    name: 'flow-report',
    meta: {
      title: '流水报告',
      icon: 'flow-report'
    },
    children: [{
        path: 'entranceGuidance',
        name: 'entrance-guidance',
        component: () => import('@/views/rma/flowReport/guide'),
        meta: {
          title: '入口引导',
          icon: 'entrance-guidance'
        }
      },
      {
        path: 'flowReport',
        name: 'report-query',
        component: () => import('@/views/rma/flowReport/index'),
        meta: {
          title: '报告查询',
          icon: 'report-query'
        }
      }
    ]
  },
  {
    path: '/recommendation',
    component: Layout,
    redirect: '/recommendation/management',
    name: 'recommendation-management',
    meta: {
      title: '推荐管理',
      icon: 'flow-report'
    },
    children: [{
        path: 'invitationCode',
        name: 'invitation-code',
        component: () => import('@/views/rma/recommendation/guide'),
        meta: {
          title: '我的邀请码',
          icon: 'entrance-guidance'
        }
      },
      {
        path: 'invitationRewards',
        name: 'invitation-rewards',
        component: () => import('@/views/rma/recommendation/index'),
        meta: {
          title: '邀请收益',
          icon: 'report-query'
        }
      },
    ]
  },
  {
    path: '/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {
      title: '权限',
      icon: 'ums'
    },
    children: [{
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {
          title: '用户列表',
          icon: 'ums-admin'
        }
      },
      {
        path: 'riskQueryList',
        name: 'riskQueryList',
        component: () => import('@/views/rma/riskQuery/RmaRiskQueryList'),
        meta: {
          title: '更改',
          icon: 'ums-menu'
        }
      },
      {
        path: 'disposalManagement',
        name: 'disposal-management',
        component: () => import('@/views/rma/riskQuery/disposalManagement'),
        meta: {
          title: '下架管理',
          icon: 'ums-menu'
        }
      },

      {
        path: 'passwordchange',
        name: 'passwordchange',
        component: () => import('@/views/ums/admin/passwordchange'),
        meta: {
          title: '安全认证',
          icon: 'ums-admin'
        }
      },
      {
        path: 'subAccount',
        name: 'subAccount',
        component: () => import('@/views/ums/subAccount/subAccount'),
        meta: {
          title: '子账户管理',
          icon: 'ums-admin'
        }
      },
      // {
      //   path: 'subAccountMessage',
      //   name: 'subAccountMessage',
      //   component: () => import('@/views/ums/subAccount/index'),
      //   meta: {
      //     title: '子账户管理'
      //   },
      //   hidden: true
      // },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {
          title: '角色列表',
          icon: 'ums-role'
        }
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {
          title: '分配菜单'
        },
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {
          title: '分配资源'
        },
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {
          title: '菜单列表',
          icon: 'ums-menu'
        }
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {
          title: '添加菜单'
        },
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {
          title: '修改菜单'
        },
        hidden: true
      },
      {
        path: 'messageReminder',
        name: 'messageReminder',
        component: () => import('@/views/rma/messageReminder/index'),
        meta: {
          title: '消息提醒列表',
          icon: 'ums-menu'
        }
      },
      {
        path: 'flowpeizhi',
        name: 'flowpeizhi',
        component: () => import('@/views/rma/informationClassification/index'),
        meta: {
          title: '流水分析配置',
          icon: 'ums-menu'
        }
      },

      {
        path: 'codeCity',
        name: 'codeCity',
        component: () => import('@/views/rma/cityRelation/index'),
        meta: {
          title: '城市编码',
          icon: 'ums-menu'
        }
      },
      {
        path: 'taskManagement',
        name: 'taskManagement',
        component: () => import('@/views/rma/taskManagement/index'),
        meta: {
          title: '任务管理',
          icon: 'ums-menu'
        }
      },
      {
        path: 'earningsWithdrawal',
        name: 'earnings-withdrawal',
        component: () => import('@/views/rma/earningswithdrawal/index'),
        meta: {
          title: '提现管理',
          icon: 'ums-admin'
        }
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {
          title: '资源分类'
        },
        hidden: true
      }
    ]
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js